import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { useGameplayConfig } from 'store';
import { storage } from 'services/config/storage';
import { languageLabels } from './constants';
import { Dropdown } from 'assets/icons';
import "./style.scss"

const LanguageSelect = ({ visible,
    className = "",
    selectClassName = "",
    handleChangeInParent = () => { },
}) => {
    const { languagesOptions, setConfigLanguageSettings } = useGameplayConfig()
    const { t } = useTranslation()

    const handleLanguageChange = async (val) => {
        const isRtlLayout = val === 'ar' ? true : false
        setConfigLanguageSettings({
            configLanguage: val,
            layoutDirection: isRtlLayout ? 'rtl' : 'ltr',
            isRtlLayout
        })
        i18n.changeLanguage(val)
        storage.set.userLang(val)
        handleChangeInParent(val)
    }

    return visible ? (
        <div className={`flex flex-col items-start ${className}`}>
            <p className="size-16 color-primary weight-400 m-0 mb-8 opacity-70">{t("login_screen.choose_language")}</p>
            <Select
                suffixIcon={<Dropdown />}
                className={`language-select ${selectClassName}`}
                popupClassName="language-select-popup"
                value={i18n?.language}
                options={languagesOptions?.map(lang => ({ value: lang, label: languageLabels[lang] }))}
                onChange={handleLanguageChange}
            />
        </div>
    ) : (<></>)
}

export default LanguageSelect